import { createState } from "states/createState";

export const { listState, currentIdState, itemState } = createState<Company>({
  name: "company",
  getId: ({ _id }) => _id,
});
